import React, { useState, FC, JSX } from 'react';
import { Link } from 'react-router-dom';
import Button from '../components/ui/Button';
import useScrollToTop from '../hooks/useScrollToTop';

const HomeNew: FC = (): JSX.Element => {
  useScrollToTop();

  // State for How Dhoondh Works tabs
  const [activeTab, setActiveTab] = useState<'jobseekers' | 'employers'>('jobseekers');

  // Vertical slider images - Column 1
  const sliderColumn1 = [
    '/newHome/slider_1/Mask group.png',
    '/newHome/slider_1/Mask group-1.png',
    '/newHome/slider_1/Mask group-2.png',
    '/newHome/slider_1/Mask group-3.png',
    '/newHome/slider_1/Mask group-4.png',
  ];

  // Vertical slider images - Column 2
  const sliderColumn2 = [
    '/newHome/slider_2/Mask group.png',
    '/newHome/slider_2/Mask group-1.png',
    '/newHome/slider_2/Mask group-2.png',
    '/newHome/slider_2/Mask group-3.png',
    '/newHome/slider_2/Mask group-4.png',
  ];

  const collegeLogos = [
    { name: 'XIM University', src: '/newHome/trusted_colleges/ximi_uni.png' },
    { name: 'University 2', src: '/newHome/trusted_colleges/msu.png' },
    { name: 'NUV', src: '/newHome/trusted_colleges/nuv_uni.png' },
    { name: 'Sigma University', src: '/newHome/trusted_colleges/sigma_uni.png' },
    { name: 'Woxsen', src: '/newHome/trusted_colleges/woxsen_uni.png' },
  ];

  const jobseekerSteps = [
    {
      number: '1',
      title: 'Create Your Profile in 5 Minutes',
      description: 'Add your skills and experience in just 2 minutes.',
    },
    {
      number: '2',
      title: 'Smart AI Matchmaking',
      description: 'AI provides suitable job options.',
    },
    {
      number: '3',
      title: 'Fast-Track Your Interviews',
      description: 'Capture employer interest in a matter of minutes.',
    },
    {
      number: '4',
      title: 'Get Hired for Free',
      description: "We don't stop working until you get hired.",
    },
  ];

  const employerSteps = [
    {
      number: '1',
      title: 'Post Your Job in 2 Minutes',
      description: 'Add job details and requirements quickly.',
    },
    {
      number: '2',
      title: 'AI Finds Perfect Candidates',
      description: 'Our AI matches you with qualified candidates.',
    },
    {
      number: '3',
      title: 'Review & Shortlist',
      description: 'Easily review applications and shortlist candidates.',
    },
    {
      number: '4',
      title: 'Hire the Best Talent',
      description: 'Connect and hire without any fees.',
    },
  ];

  const categories = [
    { name: 'Technology', jobs: 1486, companies: ['uc', 'infosys', 'ibm'] },
    { name: 'FMCG & Retail', jobs: 1486, companies: ['uc', 'infosys', 'ibm'] },
    { name: 'Health & Hospitals', jobs: 1486, companies: ['uc', 'infosys', 'ibm'] },
    { name: 'Hospitality', jobs: 1486, companies: ['uc', 'infosys', 'ibm'] },
  ];

  const featuredJobs = [
    {
      company: 'Urban Company',
      logo: '/newHome/featured_jobs/urban_company.png',
      role: 'Business Development',
      tags: ['Urgent Hiring', 'Pune'],
    },
    {
      company: 'LIC',
      logo: '/newHome/featured_jobs/lic.png',
      role: 'Business Development',
      tags: ['Urgent Hiring', 'Vadodara'],
    },
    {
      company: 'YD Advisory',
      logo: '/newHome/featured_jobs/yd_advisory.png',
      role: 'Consultant',
      tags: ['Urgent Hiring', 'Delhi'],
    },
    {
      company: 'JCB',
      logo: '/newHome/featured_jobs/jcb.png',
      role: 'Sales Executive',
      tags: ['Urgent Hiring', 'Bangalore'],
    },
  ];

  const dhoondhOffers = [
    {
      title: 'White Collar Jobs',
      description: 'From finance to design—find verified experts or land your next career move with confidence.',
      image: '/newHome/dhoondh_offers/9b75a6a4-d65f-42cb-99ed-bc4a46aab89c 1.png',
      link: '/services',
      profileCard: {
        type: 'job',
        companyLogo: '/newHome/featured_jobs/urban-company-logo.png',
        companyName: 'Urban Company',
        role: 'Senior Software Engineer',
        tags: ['Urgently Hiring', 'Gurugram', 'Hybrid']
      }
    },
    {
      title: 'Contractual Hiring',
      description: 'Select from thousands of verified workers for your factory, warehouse or production needs.',
      image: '/newHome/dhoondh_offers/Mask group.png',
      link: '/services',
      profileCard: {
        type: 'illustration',
        bannerText: 'We Build Your Dreams',
        // workerImage: '/newHome/dhoondh_offers/Mask group.png',
        illustration: '/newHome/dhoondh_offers/Mask group.png',
        tags: ['We Build Your Dreams','Multiple Staff Required']
      }
    },
    {
      title: 'Resume Builder',
      description: 'Your resume, professionally done. Stand out to employers with a clean, recruiter-approved format.',
      image: '/newHome/dhoondh_offers/Mask group.png',
      link: '/services',
      profileCard: {
        type: 'profile',
        avatar: '/newHome/dhoondh_offers/Mask group.png',
        name: 'Reeta Sinha',
        role: 'Customer Relationship Manager',
        tags: ['Immediate Joiner', 'Patna, Bihar', '6 years']
      }
    },
    {
      title: 'Blue Collar Jobs',
      description: 'Hire or find roles for technicians, helpers, logistics & more. Empowering every hand that builds the future.',
      image: '/newHome/dhoondh_offers/OBJECTS.png',
      link: '/services',
      profileCard: {
        type: 'job',
        companyLogo: '/newHome/featured_jobs/urban-company-logo.png',
        companyName: 'Urban Company',
        role: 'Makeup Artist',
        tags: ['Urgently Hiring', 'Surat', 'Service']
      }
    },
    {
      title: 'College Placements',
      description: 'Boost your campus placement rates with dedicated hiring drives and direct access to top-tier industry partners.',
      image: '/newHome/dhoondh_offers/9b75a6a4-d65f-42cb-99ed-bc4a46aab89c 1.png',
      link: '/services',
      profileCard: {
        type: 'placement',
        image: '/newHome/dhoondh_offers/9b75a6a4-d65f-42cb-99ed-bc4a46aab89c 1.png',
        tags: ['Ahmedabad', 'B. Tech.', 'Computer Science']
      }
    },
    {
      title: 'Upskill Yourself',
      description: 'Access affordable courses built around job demand - every skill you gain takes you one step closer to better work.',
      image: '/newHome/dhoondh_offers/Mask group.png',
      link: '/services',
      profileCard: {
        type: 'illustration',
        illustration: '/newHome/dhoondh_offers/OBJECTS.png'
      }
    },
  ];

  return (
    <>
      <style>{`
        @keyframes scrollUp {
          0% {
            transform: translateY(0);
          }
          100% {
            transform: translateY(-50%);
          }
        }
        @keyframes scrollDown {
          0% {
            transform: translateY(-50%);
          }
          100% {
            transform: translateY(0);
          }
        }
        .animate-scroll-up {
          animation: scrollUp 40s linear infinite;
        }
        .animate-scroll-down {
          animation: scrollDown 40s linear infinite;
        }
        .animate-scroll-up:hover,
        .animate-scroll-down:hover {
          animation-play-state: paused;
        }
      `}</style>

    <div className="min-h-screen bg-white">
      {/* Section 1: Hero Section */}
      <section className="relative overflow-hidden pt-24 md:pt-32 lg:pt-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12">
          <div className="grid lg:grid-cols-2 gap-8 lg:gap-16 items-center">
            <div className="space-y-5 md:space-y-6 order-2 lg:order-1">
              <div className="inline-flex">
                <span className="px-4 py-2 rounded-xl text-sm font-medium bg-[#B6DEB6] text-primary-black">
                  India's Most Inclusive hiring platform
                </span>
              </div>

              <h1 className="text-3xl sm:text-4xl md:text-[2.75rem] lg:text-5xl font-medium text-primary-black leading-[1.15]">
                Someone out there<br />
                is looking for exactly<br />
                what you offer.
              </h1>

              <p className="text-xl sm:text-2xl md:text-[1.75rem] font-bold text-[#007000] italic">
                "काम ढूंढना अब और आसान है."
              </p>

              <p className="text-gray-600 text-base md:text-lg max-w-lg leading-relaxed">
                Backend engineers to backend of hospital - every job, every city, one platform.
              </p>

              <div className="flex flex-col sm:flex-row gap-3 pt-2">
                <Link to="/services">
                  <Button size="lg" className="w-full sm:w-auto shadow-md">
                    Search Jobs
                  </Button>
                </Link>
                <Link to="/register">
                  <Button
                    variant="outline"
                    size="lg"
                    className="w-full sm:w-auto border-primary-lightGreen text-primary-black hover:bg-primary-teaGreen/30"
                  >
                    Post a Job Free
                  </Button>
                </Link>
              </div>

              <p className="text-[#007000] italic text-sm md:text-base">
                Are you an employer?{' '}
                <Link to="/register" className="underline hover:no-underline">
                  Post your first job free
                </Link>
              </p>
            </div>

            <div className="order-1 lg:order-2 flex justify-center lg:justify-end w-md md:w-lg lg:w-[600px] h-auto">
              <div className="relative">
                <img
                  src="/newHome/hero_section.png"
                  alt="Diverse workers representing inclusive hiring"
                  className="w-full max-w-md md:max-w-lg lg:max-w-[600px] h-auto"
                />

                <div className="absolute bottom-4 left-1/2 -translate-x-1/2 w-[90%] max-w-[500px]">
                  <div className="bg-[rgba(164,164,164,0.31)] backdrop-blur-sm rounded-2xl shadow-lg px-4 py-3">
                    <p className="text-center text-xs font-medium text-gray-600 mb-2">
                      Trusted by Colleges
                    </p>
                    <div className="flex items-center justify-center gap-3 flex-wrap">
                      {collegeLogos.map((college, index) => (
                        <img
                          key={index}
                          src={college.src}
                          alt={college.name}
                          className="h-8 md:h-12 w-auto object-contain hover:grayscale-0 transition-all duration-300"
                        />
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-6 md:mt-6 lg:mt-6 pb-12 md:pb-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-center text-lg md:text-xl font-semibold text-primary-black ">
              Trusted by Companies
            </h2>
            <div className="overflow-x-auto">
              <img
                src="/newHome/section1_footer.svg"
                alt="Trusted companies and colleges"
                className="w-full min-w-[600px] h-auto max-h-[200px] object-contain mx-auto"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Section 2: How Dhoondh Works */}
      <section className="py-16 md:py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-primary-black mb-8">
            How Dhoondh works?
          </h2>

          <div className="grid lg:grid-cols-2 gap-12 items-start">
            <div>
              {/* Tabs */}
              <div className="flex gap-4 mb-8">
                <button
                  onClick={() => setActiveTab('jobseekers')}
                  className={`px-6 py-3 rounded-full font-medium transition-all ${
                    activeTab === 'jobseekers'
                      ? 'bg-[#87DE88] text-primary-black'
                      : 'bg-white text-gray-600 hover:bg-gray-100'
                  }`}
                >
                  For Jobseekers
                </button>
                <button
                  onClick={() => setActiveTab('employers')}
                  className={`px-6 py-3 rounded-full font-medium transition-all ${
                    activeTab === 'employers'
                      ? 'bg-[#87DE88] text-primary-black'
                      : 'bg-white text-gray-600 hover:bg-gray-100'
                  }`}
                >
                  For Employers
                </button>
              </div>

              {/* Steps */}
              <div className="bg-white rounded-2xl p-6 md:p-8 shadow-sm">
                <div className="space-y-6">
                  {(activeTab === 'jobseekers' ? jobseekerSteps : employerSteps).map((step, index) => (
                    <div key={index} className="flex gap-4">
                      <div className="flex-shrink-0 w-10 h-10 rounded-full bg-[#87DE88] flex items-center justify-center text-primary-black font-bold">
                        {step.number}
                      </div>
                      <div>
                        <h3 className="font-semibold text-primary-black text-lg">{step.title}</h3>
                        <p className="text-gray-600 text-sm mt-1">{step.description}</p>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="mt-8 flex justify-end">
                  <Link to="/register">
                    <Button size="md">Create Account</Button>
                  </Link>
                </div>
              </div>
            </div>

            {/* Two Vertical Sliders */}
            <div className="grid grid-cols-2 gap-4 h-[500px] overflow-hidden">
              {/* Column 1 - Scrolls Up */}
              <div className="relative overflow-hidden">
                <div className="animate-scroll-up flex flex-col gap-4">
                  {[...sliderColumn1, ...sliderColumn1].map((img, index) => (
                    <img
                      key={`col1-${index}`}
                      src={img}
                      alt={`Slide ${index + 1}`}
                      className="w-full h-58 object-contain rounded-xl flex-shrink-0"
                    />
                  ))}
                </div>
              </div>
              
              {/* Column 2 - Scrolls Down */}
              <div className="relative overflow-hidden">
                <div className="animate-scroll-down flex flex-col gap-4">
                  {[...sliderColumn2, ...sliderColumn2].map((img, index) => (
                    <img
                      key={`col2-${index}`}
                      src={img}
                      alt={`Slide ${index + 1}`}
                      className="w-full h-58 object-contain rounded-xl flex-shrink-0"
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 3: Browse by Category */}
      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center mb-8">
            <h2 className="text-3xl md:text-4xl font-bold text-primary-black">Browse by Category</h2>
            <Link to="/services" className="text-[#87DE88] font-medium hover:underline flex items-center gap-1">
              View All Categories <span>→</span>
            </Link>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {categories.map((category, index) => (
              <Link
                key={index}
                to="/services"
                className="bg-white border border-gray-200 rounded-xl p-6 hover:shadow-lg transition-all group"
              >
                <div className="flex justify-between items-start mb-4">
                  <div>
                    <h3 className="font-semibold text-primary-black text-lg">{category.name}</h3>
                    <p className="text-gray-500 text-sm">({category.jobs} jobs)</p>
                  </div>
                  <span className="text-gray-400 group-hover:text-[#87DE88] transition-colors">→</span>
                </div>
                <div className="flex gap-2">
                  {['UC', 'Infosys', 'IBM'].map((company, i) => (
                    <div
                      key={i}
                      className={`w-8 h-8 rounded-lg flex items-center justify-center text-xs font-bold ${
                        i === 0 ? 'bg-black text-white' : i === 1 ? 'bg-blue-600 text-white' : 'bg-blue-400 text-white'
                      }`}
                    >
                      {company.substring(0, 2)}
                    </div>
                  ))}
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Section 4: Featured Jobs */}
      <section className="py-16 md:py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-primary-black mb-8">Featured Jobs</h2>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {featuredJobs.map((job, index) => (
              <div
                key={index}
                className="bg-white rounded-xl p-6 border border-gray-200 hover:shadow-lg transition-all cursor-pointer"
              >
                <div className="flex items-center gap-3 mb-4">
                  <img src={job.logo} alt={job.company} className="w-12 h-12 object-contain" />
                </div>
                <h3 className="font-semibold text-primary-black">{job.company}</h3>
                <p className="text-gray-600 text-sm mb-4">{job.role}</p>
                <div className="flex flex-wrap gap-2">
                  {job.tags?.map((tag, i) => (
                    <span key={i} className="px-2 py-1 bg-gray-100 rounded-md text-xs text-gray-600">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Section 5: Hiring Excellence CTA */}
      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="space-y-6">
              <h2 className="text-3xl md:text-4xl font-bold text-primary-black leading-tight">
                Hiring excellence is one conversation away.
              </h2>
              <p className="text-gray-600 text-lg">
                Connect with our team and learn how Dhoondh can help your team grow faster and better.
              </p>
              <Link to="/contact">
                <Button size="lg">Get in Touch</Button>
              </Link>
            </div>
            <div className="relative">
              <img
                src="/newHome/hero_section2.png"
                alt="Professional consultation"
                className="w-full max-w-md mx-auto rounded-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Section 6: What Dhoondh Offers */}
      <section className="py-16 md:py-24 bg-primary-teaGreen/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-primary-black mb-4">What Dhoondh Offers</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              We handle everything— from planning to sourcing, so you can focus on hiring the best talent.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {dhoondhOffers.map((offer, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl p-6 border border-gray-100 hover:shadow-xl transition-all group"
              >
                {/* Profile/Job Card Header */}
                <div className="mb-4">
                  {offer.profileCard.type === 'job' && (
                    <div className="bg-gray-50 rounded-xl p-4">
                      <div className="flex items-center gap-3 mb-3">
                        <div className="w-10 h-10 bg-black rounded-lg flex items-center justify-center text-white font-bold text-xs">
                          UC
                        </div>
                        <div>
                          <p className="font-semibold text-gray-900 text-sm">{offer.profileCard.companyName}</p>
                          <p className="text-gray-500 text-xs">{offer.profileCard.role}</p>
                        </div>
                      </div>
                      <div className="flex flex-wrap gap-2">
                        {offer.profileCard.tags?.map((tag, i) => (
                          <span key={i} className="px-2 py-1 bg-white rounded-md text-xs text-gray-600 border border-gray-200">
                            {tag}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}
                  
                  {offer.profileCard.type === 'banner' && (
                    <div className="bg-[#E8F5E9] rounded-xl p-4 relative overflow-hidden">
                      <div className="flex items-center justify-between">
                        <div className="flex -space-x-2">
                          <div className="w-12 h-12 rounded-full bg-yellow-400 border-2 border-white flex items-center justify-center">
                            <span className="text-xl">👷</span>
                          </div>
                          <div className="w-12 h-12 rounded-full bg-green-400 border-2 border-white flex items-center justify-center">
                            <span className="text-xl">👷‍♂️</span>
                          </div>
                        </div>
                        <div className="bg-white rounded-lg px-3 py-2 shadow-sm">
                          <p className="text-xs font-medium text-gray-800 text-center">We Build<br/>Your Dreams</p>
                        </div>
                      </div>
                      <div className="mt-3">
                        <span className="px-2 py-1 bg-white rounded-md text-xs text-gray-600 border border-gray-200">
                          {offer.profileCard.tags?.[0]}
                        </span>
                      </div>
                    </div>
                  )}
                  
                  {offer.profileCard.type === 'profile' && (
                    <div className="bg-gray-50 rounded-xl p-4">
                      <div className="flex items-center gap-3 mb-3">
                        <div className="w-12 h-12 rounded-full bg-gradient-to-br from-purple-400 to-pink-400 overflow-hidden">
                          <img src={offer.profileCard.avatar} alt={offer.profileCard.name} className="w-full h-full object-cover" />
                        </div>
                        <div>
                          <p className="font-semibold text-gray-900 text-sm">{offer.profileCard.name}</p>
                          <p className="text-gray-500 text-xs">{offer.profileCard.role}</p>
                        </div>
                      </div>
                      <div className="flex flex-wrap gap-2">
                        {offer.profileCard.tags?.map((tag, i) => (
                          <span key={i} className="px-2 py-1 bg-white rounded-md text-xs text-gray-600 border border-gray-200">
                            {tag}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}
                  
                  {offer.profileCard.type === 'placement' && (
                    <div className="bg-[#E8F5E9] rounded-xl p-4">
                      <div className="flex items-center gap-3">
                        <div className="w-16 h-16 rounded-xl overflow-hidden bg-gradient-to-br from-blue-400 to-purple-500 flex items-center justify-center">
                          <img 
                            src={offer.profileCard.image} 
                            alt="Graduate" 
                            className="w-full h-full object-cover"
                            onError={(e) => {
                              const target = e.target as HTMLImageElement;
                              target.style.display = 'none';
                              const parent = target.parentElement as HTMLElement;
                              if (parent) {
                                parent.innerHTML = '<span class="text-2xl">🎓</span>';
                              }
                            }}
                          />
                        </div>
                      <div className="flex flex-wrap gap-2">
                        {offer.profileCard.tags?.map((tag, i) => (
                          <span key={i} className="px-2 py-1 bg-white rounded-md text-xs text-gray-600 border border-gray-200">
                            {tag}
                          </span>
                        ))}
                      </div>
                      </div>
                    </div>
                  )}
                  
                  {offer.profileCard.type === 'illustration' && (
                    <div className="rounded-xl p-4 flex items-center justify-center" style={{background: 'linear-gradient(135deg, #E8F5E9 0%, #C8E6C9 100%)'}}>
                      <img 
                        src={offer.profileCard.illustration} 
                        alt="Upskill" 
                        className="w-full h-24 object-contain"
                      />
                    </div>
                  )}
                </div>

                <h3 className="font-semibold text-primary-black text-xl mb-2">{offer.title}</h3>
                <p className="text-gray-600 text-sm mb-4 leading-relaxed">{offer.description}</p>
                <Link
                  to={offer.link}
                  className="text-[#87DE88] font-medium hover:underline inline-flex items-center gap-1 group-hover:gap-2 transition-all"
                >
                  View Plans 
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                  </svg>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Section 7: Footer */}
      {/* {footer()} */}
    </div>
  </>
  );
};

const footer = () => {
  return
   <footer className="bg-white border-t border-gray-200 pt-16 pb-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
            {/* Brand Column */}
            <div className="space-y-4">
              <img
                src="/logo-top-left.svg"
                alt="Dhoondh"
                className="h-8"
                onError={(e) => {
                  (e.target as HTMLImageElement).style.display = 'none';
                }}
              />
              <p className="text-gray-600 italic text-sm">"तुरंत पोस्ट करो और पाओ परफेक्ट मैच!ढूंढ के तो देखो..."</p>
              <div className="space-y-2">
                <a href="mailto:operations@dhoondh.in" className="flex items-center gap-2 text-gray-600 hover:text-[#87DE88]">
                  <svg className="w-5 h-5 text-[#87DE88]" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                    <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                  </svg>
                  operations@dhoondh.in
                </a>
                <a href="tel:+919316846322" className="flex items-center gap-2 text-gray-600 hover:text-[#87DE88]">
                  <svg className="w-5 h-5 text-[#87DE88]" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                  </svg>
                  +91 93168 46322
                </a>
              </div>
            </div>

            {/* For Candidates */}
            <div>
              <h4 className="font-semibold text-primary-black mb-4">For Candidates</h4>
              <ul className="space-y-3">
                <li>
                  <Link to="/register" className="text-gray-600 hover:text-[#87DE88]">
                    Create Profile
                  </Link>
                </li>
                <li>
                  <Link to="/services" className="text-gray-600 hover:text-[#87DE88]">
                    Resume Builder
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="text-gray-600 hover:text-[#87DE88]">
                    Contact Us
                  </Link>
                </li>
              </ul>
            </div>

            {/* For Companies */}
            <div>
              <h4 className="font-semibold text-primary-black mb-4">For Companies</h4>
              <ul className="space-y-3">
                <li>
                  <Link to="/register" className="text-gray-600 hover:text-[#87DE88]">
                    Register Company
                  </Link>
                </li>
                <li>
                  <Link to="/register" className="text-gray-600 hover:text-[#87DE88]">
                    Post a Job
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="text-gray-600 hover:text-[#87DE88]">
                    Contact Sales
                  </Link>
                </li>
              </ul>
            </div>

            {/* Stay in Touch */}
            <div>
              <h4 className="font-semibold text-primary-black mb-4">Stay in Touch</h4>
              <div className="flex gap-3 mb-6">
                <a
                  href="https://wa.me/919316846322"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center hover:bg-[#87DE88] transition-colors"
                >
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M20.52 3.48A11.94 11.94 0 0012.06.03C5.64.03.45 5.22.45 11.64c0 2.05.54 4.05 1.57 5.82L.02 24l6.69-2.02a11.7 11.7 0 005.35 1.34h.01c6.43 0 11.62-5.19 11.62-11.61 0-3.1-1.21-6.02-3.17-8.23z" />
                  </svg>
                </a>
                <a
                  href="https://www.linkedin.com/company/dhoondh-ltd/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center hover:bg-[#87DE88] transition-colors"
                >
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                  </svg>
                </a>
                <a
                  href="https://www.instagram.com/dhoondh.in"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center hover:bg-[#87DE88] transition-colors"
                >
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
                  </svg>
                </a>
              </div>
              <div className="space-y-2">
                <input
                  type="email"
                  placeholder="Enter email to Subscribe"
                  className="w-full px-4 py-2 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#87DE88]"
                />
                <Button className="w-full">Subscribe</Button>
              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="border-t border-gray-200 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-sm text-gray-500">
              © 2025 Dhoondh. All rights reserved.<br />
              AMPS DHOONDH RECRUITMENT LLP
            </div>
            <div className="flex gap-6 text-sm">
              <Link to="/privacy" className="text-gray-600 hover:text-[#87DE88]">Privacy</Link>
              <Link to="/terms" className="text-gray-600 hover:text-[#87DE88]">Terms</Link>
              <Link to="/cookies" className="text-gray-600 hover:text-[#87DE88]">Cookies</Link>
              <Link to="/faq" className="text-gray-600 hover:text-[#87DE88]">FAQ</Link>
              <Link to="/cancellation-refunds" className="text-gray-600 hover:text-[#87DE88]">Refunds</Link>
            </div>
          </div>
        </div>
      </footer>
}
export default HomeNew;
